import { ReferenceViewID } from './types.ts';

export function isRecommendedCompID(id: ReferenceViewID): boolean {
  return id.includes('tkl:');
}
